import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@/components/ui/Icon'
import { TabBar } from '@/components/layout/TabBar'
import { CHEF_TABS } from '@/app/navigation/tabs'

export default function Navbar() {
  const { pathname } = useLocation()
  return <TabBar items={CHEF_TABS.map(tab => {
    const active = tab.matches(pathname)
    return {
      id: tab.id,
      label: tab.label,
      active,
      icon: <Icon as={tab.icon} size="lg" weight={active ? 'fill' : 'light'} color="var(--color-text)" />,
      render: props => <Link to={tab.path} {...props} />,
    }
  })} />
}
